<div class="game-stat" *ngIf="game && statistic">
  <div class="stats-values">
    <div class="stat-row">
      <div class="value">{{ statistic.team.tries || 0 }}</div>
      <div class="name">Попытки</div>
      <div class="value">{{ statistic.competitorTeam.tries || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.conversionGoals || 0 }}</div>
      <div class="name">Реализации</div>
      <div class="value">{{ statistic.competitorTeam.conversionGoals || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.conversionGoalsPercent || 0 }}%</div>
      <div class="name">% реализаций</div>
      <div class="value">{{ statistic.competitorTeam.conversionGoalsPercent || 0 }}%</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.dropGoals || 0 }}</div>
      <div class="name">Дроп-голы</div>
      <div class="value">{{ statistic.competitorTeam.dropGoals || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.penaltyTries || 0 }}</div>
      <div class="name">Штрафные попытки</div>
      <div class="value">{{ statistic.competitorTeam.penaltyTries || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.penaltyGoals || 0 }}</div>
      <div class="name">Штрафные голы</div>
      <div class="value">{{ statistic.competitorTeam.penaltyGoals || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.penaltyGoalsPercent || 0 }}%</div>
      <div class="name">% реализации штрафных ударов</div>
      <div class="value">{{ statistic.competitorTeam.penaltyGoalsPercent || 0 }}%</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.scrums }}</div>
      <div class="name">Схватки</div>
      <div class="value">{{ statistic.competitorTeam.scrums }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.scrumsWonPercent || 0 }}%</div>
      <div class="name">% выигранных схваток</div>
      <div class="value">{{ statistic.competitorTeam.scrumsWonPercent || 0 }}%</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.mauls || 0 }}</div>
      <div class="name">Молы</div>
      <div class="value">{{ statistic.competitorTeam.mauls || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.maulWonPercent || 0 }}%</div>
      <div class="name">% выигранных молов</div>
      <div class="value">{{ statistic.competitorTeam.maulWonPercent || 0 }}%</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.rucks || 0 }}</div>
      <div class="name">Раки</div>
      <div class="value">{{ statistic.competitorTeam.rucks || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.rucksWonPercent || 0 }}%</div>
      <div class="name">% выигранных раков</div>
      <div class="value">{{ statistic.competitorTeam.rucksWonPercent || 0 }}%</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.lineouts || 0 }}</div>
      <div class="name">Коридоры</div>
      <div class="value">{{ statistic.competitorTeam.lineouts || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.lineoutsWonPercent || 0 }}%</div>
      <div class="name">% выигранных коридоров</div>
      <div class="value">{{ statistic.competitorTeam.lineoutsWonPercent || 0 }}%</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.footFieldShots || 0 }}</div>
      <div class="name">Удары ногой в поле</div>
      <div class="value">{{ statistic.competitorTeam.footFieldShots || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.footOutShots || 0 }}</div>
      <div class="name">Удары ногой в аут</div>
      <div class="value">{{ statistic.competitorTeam.footOutShots || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.totalFouls || 0 }}</div>
      <div class="name">Получено штрафных</div>
      <div class="value">{{ statistic.competitorTeam.totalFouls || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.yellowCards || 0 }}</div>
      <div class="name">Жёлтые карточки</div>
      <div class="value">{{ statistic.competitorTeam.yellowCards || 0 }}</div>
    </div>
    <div class="stat-row">
      <div class="value">{{ statistic.team.redCards || 0 }}</div>
      <div class="name">Красные карточки</div>
      <div class="value">{{ statistic.competitorTeam.redCards || 0 }}</div>
    </div>
  </div>
</div>
